import React from 'react';
import { HighchartsReactRefObject } from 'highcharts-react-official';

import Loading from '../../Loading';
import usePieData from '../Pie/PieContent/usePieData';
import PieView from '../Pie/PieContent/PieView';

// A donut is a pie with a larger central hole. It reuses the pie data pipeline
// (usePieData) and view (PieView), only overriding the slice inner size.
const DONUT_INNER_SIZE = '65%';

const DonutContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<HighchartsReactRefObject | null>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = usePieData({
    chartDefinition,
    chartRef,
    innerSize: DONUT_INNER_SIZE,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <PieView
      chartRef={chartRef}
      options={options!}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default DonutContent;
